import script from "./StepOrdering.vue?vue&type=script&setup=true&lang=js"
export * from "./StepOrdering.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import AmountField from "@/components/neue/wizard/AmountField.vue";
import NumberStepper from "@/components/neue/wizard/NumberStepper.vue";
import PillRadioGroup from "@/components/neue/wizard/PillRadioGroup.vue";
import SegmentedControl from "@/components/neue/SegmentedControl.vue";
import SelectInput from "@/components/neue/SelectInput.vue";
import SelectionCard from "@/components/neue/wizard/SelectionCard.vue";
import SelectionGroup from "@/components/neue/wizard/SelectionGroup.vue";
import ToggleRow from "@/components/neue/wizard/ToggleRow.vue";
import WeekdayPicker from "@/components/neue/wizard/WeekdayPicker.vue";
import WizardButton from "@/components/neue/wizard/WizardButton.vue";
import WizardSection from "@/components/neue/wizard/WizardSection.vue";
script.components = Object.assign({}, { AmountField, NumberStepper, PillRadioGroup, SegmentedControl, SelectInput, SelectionCard, SelectionGroup, ToggleRow, WeekdayPicker, WizardButton, WizardSection }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { AmountField, NumberStepper, PillRadioGroup, SegmentedControl, SelectInput, SelectionCard, SelectionGroup, ToggleRow, WeekdayPicker, WizardButton, WizardSection }, script.__o.components);}